import { defineComponent as _defineComponent } from 'vue'
import InvoicesCurrent from '@/views/my-projects/components/invoices/InvoicesCurrent.vue';
import InvoicesIncoming from '@/views/my-projects/components/invoices/InvoicesIncoming.vue';
import InvoicesOutgoing from '@/views/my-projects/components/invoices/InvoicesOutgoing.vue';
import InvoicesActions from '@/views/my-projects/components/invoices/action-box/InvoicesActions.vue';
import { onMounted } from 'vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import MyProjectInvoiceConfirms from '@/views/my-projects/pages/MyProjectInvoiceConfirms.vue';
import InvoicesDraft from '@/views/my-projects/components/invoices/InvoicesDraft.vue';
import useUser from '@/mixins/useUser';
import { UserType } from '@/models/User';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsInvoices',
  setup(__props) {

const { fetchInvoices } = useInvoice();
const { type } = useUser('self');

onMounted(async () => {
  await fetchInvoices();
});

return { __sfc: true,fetchInvoices, type, InvoicesCurrent, InvoicesIncoming, InvoicesOutgoing, InvoicesActions, MyProjectInvoiceConfirms, InvoicesDraft, UserType }
}

})